<template>
  <div class="navigation" v-if="!$route.meta.hideNavigation">
    <div>
      <router-link class="navigation__logo-link" :to="{ name: 'home' }" tabindex="-1">
        <img src="@/assets/images/S.svg" alt="Stifta logotyp" class="logo" />
        <span class="navigation__title">{{ $store.getters.currentTrustName }}</span>
      </router-link>
      <nav v-if="navigation">
        <div v-for="item in navigation.items" :key="item.label" class="navigation__item-container">
          <router-link class="navigation__item" tabindex="-1" :to="item.to">
            <span v-if="item.icon" class="navigation__icon">
              <font-awesome-icon :icon="item.icon" fixed-width />
            </span>
            <span class="navigation__label">{{ item.label }}</span>
          </router-link>
          <div v-if="item.children && item.children.length > 0" class="navigation__submenu">
            <template v-for="child in item.children">
              <hr
                v-if="child.type === 'divider'"
                :key="child.label"
                style="color: rgba(0,0,0,.2);margin-left: 32px;margin-top: 3px;margin-bottom: 3px;"
              />
              <router-link v-else :key="child.label" class="navigation__subitem" tabindex="-1" :to="child.to">{{
                child.label
              }}</router-link>
            </template>
          </div>
        </div>
        <div class="navigation__item-container">
          <a class="navigation__item" v-on:click="logout()" tabindex="-1">
            <span class="navigation__icon">
              <font-awesome-icon :icon="['fal', 'sign-out']" flip="horizontal" fixed-width />
            </span>
            <span class="navigation__label">Logga ut</span>
          </a>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Navigation from '@/util/navigation'

export default Vue.extend({
  name: 'side-navigation',
  props: {},
  data() {
    return {
      navigation: null
    }
  },
  mounted() {
    this.navigation = new Navigation(this.$route)
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
      this.$router.push({ name: 'auth' })
    }
  },
  computed: {}
})
</script>
